import PropTypes from 'prop-types';

import { ListingCostsShape } from '../../constants/shapes';

import OnBookingClosed from './OnBookingClosed';

import styles from './PaymentDetails.module.scss';

const PaymentDetails = ({
  listingCosts = {},
  pricing = {},
  downPaymentTimeInterval = undefined,
  isInstantBooking = false,
  currencyIsoCode
}) => {
  return (
    <div className={styles['payment-details']}>
      <OnBookingClosed
        currencyCode={currencyIsoCode}
        pricing={pricing}
        costs={listingCosts?.onBookingClosed}
        downPaymentTimeInterval={downPaymentTimeInterval}
        isInstantBooking={isInstantBooking}
      />
    </div>
  );
};

PaymentDetails.propTypes = {
  pricing: PropTypes.shape({
    currencyCode: PropTypes.string,
    currencyIsoCode: PropTypes.string,
    totalContractValue: PropTypes.number
  }),
  listingCosts: PropTypes.shape({
    onBookingClosed: ListingCostsShape
  }),
  downPaymentTimeInterval: PropTypes.shape({
    type: PropTypes.oneOf(['months', 'weeks']),
    value: PropTypes.number
  }),
  isInstantBooking: PropTypes.bool,
  currencyIsoCode: PropTypes.string.isRequired
};

export default PaymentDetails;
